export default {
  login: {
    title: '登入我的頁面',
    double_check_text: '輸入的資料不正確，請重新確認。',
    id_email: 'ID／電子郵件地址',
    password: '密碼',
    password_display: '顯示密碼',
    password_no_display: '不顯示密碼',
    login: '登入',
    keep_login_text: '儲存登入資料',
    forgot_password_text: '忘記密碼請點此',
    contact_us: '未登錄者請聯絡我們',
    asuene_service_outline: '將CO2可視化的雲端服務「ASUENE」',
    // asuene_lca_service_outline: '',
    asuene_career_service_outline: 'GX、ESG人才特化型轉職平台「ASUENE CAREER」',
    corporate_page: '企業網站',
    // cross_use: {
    //   title: '',
    //   asuene_product: {
    //     banner_title: '',
    //     flag_text: '',
    //     left_btn_label: '',
    //     left_btn_link: '',
    //     right_btn_label: '',
    //     right_btn_link: '',
    //   },
    //   footer_note: ''
    // }
  },
}
